'use client';

import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Check from '@alltrails/denali/icons/Check';
import Download from '@alltrails/denali/icons/Download';
import Link from '@alltrails/denali/icons/Link';
import { COLOR_NEUTRAL_800 } from '@alltrails/denali/tokens';
import LinkedInIcon from '@alltrails/layout/components/socialIcons/LinkedInIcon';
import TwitterIcon from '@alltrails/layout/components/socialIcons/TwitterIcon';
import styles from './styles/styles.module.scss';

const pressKitUrl = 'https://www.dropbox.com/scl/fo/g0rqlov7junzuljyjk8uw/ADFx0onwClg9g0aOb0r2nNA?rlkey=90qesjadcvk95dryzo7ho85yw&st=bbeeaedn&dl=0';

const PressReleaseSidebar = () => {
  const intl = useIntl();
  const [showCopySuccess, setShowCopySuccess] = useState(false);

  const copyValue = () => {
    navigator.clipboard.writeText(window.location.href);
    setShowCopySuccess(true);
    setTimeout(() => {
      setShowCopySuccess(false);
    }, 1000);
  };

  return (
    <div className={styles.wrapper}>
      <a className={styles.pressKit} href={pressKitUrl} target="_blank">
        <FormattedMessage defaultMessage="Download press kit" />
        <Download size="md" color="currentColor" className={styles.downloadIcon} />
      </a>
      <div className={styles.shareWrapper}>
        <div>
          <FormattedMessage defaultMessage="Share" />
        </div>
        <div className={styles.buttons}>
          <button className={styles.copyButton} aria-label={intl.formatMessage({ defaultMessage: 'Copy link' })} onClick={copyValue}>
            {showCopySuccess ? <Check size="sm" color="currentColor" /> : <Link size="sm" color="currentColor" />}
          </button>
          <LinkedInIcon openInNewTab className={styles.link} color={COLOR_NEUTRAL_800} />
          <TwitterIcon openInNewTab className={styles.link} color={COLOR_NEUTRAL_800} />
        </div>
      </div>
    </div>
  );
};

export default PressReleaseSidebar;
